import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import utils from "@/utils/index";
// import { Mutations } from "@/store/enums/StoreEnums";
import DocMenuConfig from "@/core/config/MainMenuConfig";

const redirectToHashRoute = () => {
  if (typeof window === "undefined") {
    return;
  }

  const { origin, pathname, search, hash } = window.location;

  // Já está no formato com hash.
  if (hash) {
    return;
  }

  // Não existe caminho para converter.
  if (!pathname || pathname === "/") {
    return;
  }

  const pathParts = pathname.split("/").filter(Boolean);

  if (pathParts.length < 2) {
    return;
  }

  // Primeiro segmento: diretório onde a aplicação está publicada.
  const applicationPath = pathParts.shift();

  // O restante é a rota que deve ficar depois do #.
  const routePath = pathParts.join("/");

  if (!applicationPath || !routePath) {
    return;
  }

  const newUrl = `${origin}/${applicationPath}/#/${routePath}${search}`;

  window.location.replace(newUrl);
};

redirectToHashRoute();

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:url/releases/:slug?",
    name: "public-releases",
    component: () => import("@/views/releases/Publica.vue"),
    meta: { pageTitle: "Release", public: true },
  },
  {
    path: "/:url/",
    name: "nav",
    redirect: (to) => {
      let urlWL = to.params.url ? String(to.params.url) : "";
      const isValidUrl = (url: string) => url.length > 0 && url.length <= 255;
      if (!isValidUrl(urlWL)) {
        const pathParts = to.path.split("/");
        if (pathParts.length > 1 && isValidUrl(pathParts[1])) {
          urlWL = pathParts[1];
        }
      }

      return `/${urlWL}/sign-in`;
    },
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/:url/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          pageTitle: "Dashboard",
          breadcrumbs: ["Dashboard"],
        },
      },
      {
        path: "/:url/principal/releases",
        name: "internal-releases",
        component: () => import("@/views/releases/Publica.vue"),
        meta: {
          pageTitle: "Novidades do Sistema",
          breadcrumbs: ["Novidades"],
        },
      },
      {
        path: "/:url/assistant/relatorios",
        name: "assistant/relatorios",
        component: () =>
          import("@/views/assistant/reports/AssistantReportBuilder.vue"),
        meta: {
          pageTitle: "Relatórios do Assistente",
          breadcrumbs: ["Assistente", "Relatórios"],
        },
      },
    ],
  },
  {
    path: "/:url/",
    //component: () => import("@/components/page-layouts/Auth.vue"),
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/:url/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
        meta: {
          pageTitle: "Entrar",
        },
      },
      {
        path: "/:url/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
      {
        path: "/:url/register",
        name: "register",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/Register.vue"),
      },
    ],
  },
  {
    path: "/:url/",
    component: () => import("@/components/page-layouts/Market.vue"),
    children: [
      {
        path: "/:url/market",
        name: "market",
        component: () => import("@/views/market/Market.vue"),
        children: [
          {
            path: "/:url/market/produto/:loja/:id",
            name: "market/produto/:loja/:id",
            component: () => import("@/views/market/Produto.vue"),
          },
        ],
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   redirect: "/404",
  // },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export const initMenu = async () => {
  const user = localStorage.getItem("user");

  if (DocMenuConfig.length === 1 && user != null) {
    const userp = JSON.parse(user || "{}");
    await store.dispatch("menu/montarMenu", userp);
  }
};

router.beforeEach(async (to, from, next) => {
  // reset config to initial state
  //store.commit(Mutations.RESET_LAYOUT_CONFIG);
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);

  let urlWL = to.params.url ? String(to.params.url) : "";
  const isPublicRoute = to.matched.some((route) => route.meta.public === true);
  const storedUrl = utils.getWL();
  const configWL = utils.getConfigWL();

  const isValidUrl = (url: string) => url.length > 0 && url.length <= 255;

  if (!isValidUrl(urlWL)) {
    const pathParts = to.path.split("/");
    if (pathParts.length > 1 && isValidUrl(pathParts[1])) {
      urlWL = pathParts[1];
    }
  }

  const requestedUrl = urlWL;

  if (
    isValidUrl(urlWL) &&
    (!isValidUrl(storedUrl) || storedUrl !== urlWL || configWL === undefined)
  ) {
    localStorage.removeItem("url");
    sessionStorage.removeItem("configWL");
    try {
      const ret = await store.dispatch(
        "configuracaoWhiteLabel/carregarUrl",
        urlWL
      );
      if (ret.Success === true) {
        if (ret.Data) {
          localStorage.setItem("url", urlWL);
          sessionStorage.setItem("configWL", JSON.stringify(ret.Data));
          await store.dispatch("menu/desmontarMenu");
        } else {
          urlWL = "";
        }
      } else {
        urlWL = "";
      }
    } catch (error) {
      urlWL = "";
    }
  }

  if (isPublicRoute && !isValidUrl(urlWL) && isValidUrl(requestedUrl)) {
    urlWL = requestedUrl;
    localStorage.setItem("url", requestedUrl);
  }

  utils.atualizarWL();

  if (!isValidUrl(urlWL) && !isPublicRoute && !to.path.includes("/404")) {
    next(`/${utils.getWL()}/sign-in`);
    return;
  }

  //Carregar usuarios
  //const user = JSON.parse(localStorage.getItem("user") || "{}");
  const user = localStorage.getItem("user");

  if (DocMenuConfig.length === 1 && user != null) {
    const userp = JSON.parse(user || "{}");
    await store.dispatch("menu/montarMenu", userp);
  }

  next();
});

export default router;
